export default "__VITE_ASSET__DDZS1Wql__"